import React, { useContext } from "react";
import { Button, Card, Result } from "antd";
import { useLoader } from "../../Context/LoaderContext";

interface SuccessResultProps {
  title: string;
  subTitle: string;
  onClick?: () => void;
  buttonTitle?: string;
}
const SuccessResult: React.FC<SuccessResultProps> = ({
  title,
  subTitle,
  onClick,
  buttonTitle,
}) => {
  const { isLoading, setLoading } = useLoader();

  return (
    <Card className="blur_card">
      <Result
        status="success"
        title={title}
        subTitle={subTitle}
        extra={
          onClick && (
            <Button type="primary" onClick={onClick} loading={isLoading}>
              {buttonTitle ? buttonTitle : "Button"}
            </Button>
          )
        }
      />
    </Card>
  );
};

export default SuccessResult;
